/**
 * AI 어시스턴트 터미널 UI
 * 리팩토링: useAssistant 훅 + MessageItem 컴포넌트 분리
 */

import React, { useState, useRef, useEffect } from 'react';
import { useAssistant } from './useAssistant';
import MessageItem from './MessageItem';
import './Terminal.css';

function Terminal({ onClose }) {
  const { messages, isLoading, sendMessage, clearMessages } = useAssistant();
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  // 스크롤 자동 이동
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // 입력창 포커스
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // 제안 질문
  const suggestions = [
    '넷플릭스 패스워드가 뭐야?',
    '쿠팡 패스워드 저장해줘',
    '저장된 패스워드 목록 보여줘',
    '우리카드 정보 알려줘',
    '클로드 API 키 뭐야?'
  ];

  // 메시지 전송
  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!input.trim() || isLoading) return;

    const userMessage = input.trim();
    setInput('');
    await sendMessage(userMessage);
  };

  // 제안 클릭
  const handleSuggestion = (suggestion) => {
    setInput(suggestion);
    inputRef.current?.focus();
  };

  return (
    <div className="terminal-container">
      {/* 헤더 */}
      <div className="terminal-header">
        <div className="terminal-buttons">
          <span className="btn-close" onClick={onClose}></span>
          <span className="btn-minimize"></span>
          <span className="btn-maximize"></span>
        </div>
        <div className="terminal-title">AI 어시스턴트</div>
        <button className="btn-clear" onClick={clearMessages}>초기화</button>
      </div>

      {/* 메시지 영역 */}
      <div className="terminal-messages">
        {/* 환영 메시지 */}
        {messages.length === 0 && (
          <div className="welcome-message">
            <div className="welcome-icon">🤖</div>
            <h3>Password Wallet AI</h3>
            <p>패스워드, 신용카드, API 키, 메모를 검색하고 관리합니다.</p>
            <div className="suggestions">
              {suggestions.map((s, i) => (
                <button
                  key={i}
                  className="suggestion-btn"
                  onClick={() => handleSuggestion(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* 메시지 목록 */}
        {messages.map((msg) => (
          <MessageItem key={msg.id} message={msg} />
        ))}

        {/* 로딩 */}
        {isLoading && (
          <div className="message assistant loading">
            <div className="message-avatar">🤖</div>
            <div className="message-content">
              <div className="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div className="loading-text">생각 중...</div>
            </div>
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      {/* 입력 영역 */}
      <form className="terminal-input" onSubmit={handleSubmit}>
        <span className="prompt">pw@wallet:~$</span>
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="질문을 입력하세요..."
          disabled={isLoading}
        />
        <button type="submit" disabled={isLoading || !input.trim()}>
          전송
        </button>
      </form>
    </div>
  );
}

export default Terminal;
